const VALIDITY_DEFAULTS = {
  badInput: false,
  customError: false,
  patternMismatch: false,
  rangeOverflow: false,
  stepMismatch: false,
  tooLong: false,
  tooShort: false,
  typeMismatch: false,
  valid: true,
  valueMissing: false,
  dirty: false,
};

const VALIDITY_MESSAGES = {
  badInput: {
    default: 'Input is not valid',
  },
  customError: {
    default: 'This is a custom error',
    abn: "Hmmm that doesn't look right",
    spamMessage: 'Oops! Remember not to include any personal information.',
    missingAreaCode: 'Oops! Missing area code.',
    filterWords:
      'Whoops! Your review cannot be submitted as it contains inappropriate language.',
  },
  patternMismatch: {
    default: 'Invalid pattern match',
    phone: "Oops! That isn't a valid number",
    validName: 'Oops, that isn’t a valid name.',
    specialCharacters:
      'Oops, looks like you entered a special character and/or a number.',
    spamMessage: 'Oops! Remember not to include any personal information.',
  },
  rangeOverflow: {
    default: 'Range overflow',
  },
  stepMismatch: {
    default: 'Step mismatch',
  },
  tooLong: {
    default: 'Input is too long',
    phone: 'Oops, that isn’t a valid number.',
  },
  tooShort: {
    default: 'Input is too short',
    messageMin4: 'Please enter at least 4 characters.',
    messageMin50: 'Please enter at least 50 characters.',
    reviewMessage: 'Please provide some information about your experience.',
    name: 'Let us know what we can call you.',
    message: 'Oops! Please provide more detail.',
  },
  typeMismatch: {
    default: 'This is a bad input',
    validEmail: 'Oops, that isn’t a valid email.',
    website: 'Please ensure your website starts with http:// or https://',
    email:
      "Hmm... That doesn't look right. Please check it and enter a valid email address.",
  },
  valid: {
    default: 'Input is not valid',
    name: 'Let us know what we can call you.',
    businessName: 'Oops, please provide your business name.',
    agencyName: 'Oops, please provide your agency name.',
    validName: 'Oops, that isn’t a valid name.',
    validEmail: 'Oops, that isn’t a valid email.',
    email: 'Oops, that isn’t a valid email.',
    phone: 'Oops, that isn’t a valid number.',
    suburb: 'Please try another location.',
    message: 'Please add a little bit more detail.',
    dropdown: 'Please select from the dropdown.',
    date: 'Please select a valid date.',
    category:
      "Customers won't be able to find you without a selected industry. Please complete to continue.",
    quotableCategory: 'Oops! Looks like nothing is selected.',
  },
  valueMissing: {
    default: 'Input is missing',
    name: 'Let us know what we can call you.',
    rating: 'Please add a rating.',
    businessName: 'Oops, please provide your business name.',
    agencyName: 'Oops, please provide your agency name.',
    abn: 'Oops, please provide your ABN.',
    validName: 'Oops, that isn’t a valid name.',
    validEmail: 'Oops, that isn’t a valid email.',
    email: 'Oops, that isn’t a valid email.',
    phone: 'Oops, that isn’t a valid number.',
    suburb: 'Please enter a location.',
    message: 'Please provide more information.',
    reviewMessage: 'Please provide some information about your experience.',
    dropdown: 'Oops! Looks like nothing is selected.',
    date: 'Please select a valid date.',
    category:
      "Customers won't be able to find you without a selected industry. Please complete to continue.",
    quotableCategory: 'Oops! Looks like nothing is selected.',
  },
  dirty: {
    default: 'Input is dirty',
  },
};

export { VALIDITY_DEFAULTS, VALIDITY_MESSAGES };
